import { RawTestLabel, TestLabel } from "@/types/testLabel";
import { mapRawSpecToSpec } from "./specList";
import { mapRawToStructure } from "./structure";

export const mapRawToTestLabel = (raw: RawTestLabel): TestLabel => {
  return {
    createdAt: new Date(raw.created_at),
    createdBy: raw.created_by,
    description: raw.description,
    maskSpecific: raw.mask_specific,
    name: raw.name,
    mask: {
      id: raw.mask.id,
      name: raw.mask.name,
    },
    id: raw.id,
    specListId: raw.spec_list_id,
    status: raw.status,
    linkedSpecs: raw.linked_specs.map(mapRawSpecToSpec),
    linkedStructures: raw.linked_structures.map(mapRawToStructure),
    measurementCapabilityId: raw.measurement_capability_id ?? "",
    measurementCapability: raw.measurement_capability,
    calculatedMeasTimePerDie: raw.calculated_meas_time_per_die,
    isArchived: raw.is_archived,
  };
};
